<script lang="ts">
  import { authStore } from "../../auth/auth-store";
  import LoginPage from "./LoginPage.svelte";
  import MainApp from "./MainApp.svelte";
</script>

{#if $authStore.token}
  {#key $authStore.token}
    <MainApp />
  {/key}
{:else}
  <LoginPage />
{/if}
